import apiClient from '@src/api/clients';

const BASE_URL = 'dashboard/feed-health/';

const cleanParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== ''),
  );

// Staff feed & backend-data health board.
// params: {
//   problems_only: bool,     // only rows whose health is a problem
//   include_archived: bool,  // also list archived mappings
//   client_id / parent_company: id,  // optional scope narrowing
//   fresh: bool,             // bypass the short server cache (use after a
//                            //   mutating action so the caller sees its change)
// }
export const fetchFeedHealth = (params = {}) =>
  apiClient.request({ url: BASE_URL, method: 'GET', payload: cleanParams(params) });

export default { fetchFeedHealth };
